import {  Result } from 'antd';
import React from 'react';
import CardLayout from '../../layouts/CardLayout';
import { Link } from '../../utils/i18n';
import { FormattedMessage } from 'react-intl';
import Button from '../../pages/Contact/Button';
import styles from './index.module.less';

const NotFound: React.FC = () => {
  return (
    <CardLayout centered>
      <Result
        status={404}
        title="404"
        subTitle={<FormattedMessage id="NotFound.Text" />}
        extra={
          <Link to="/support/">
            <Button className={styles.button} type="primary"><FormattedMessage id="NotFound.Button.BackHome" /></Button>
          </Link>
        }
      />
    </CardLayout>
  )
}

export default NotFound;